import { render } from "./DeleteConfirmationDialog.vue?vue&type=template&id=e34d3cdc&scoped=true"
import script from "./DeleteConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmationDialog.vue?vue&type=script&lang=js"

import "./dialog.scss?vue&type=style&index=0&id=e34d3cdc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e34d3cdc"]])

export default __exports__